var WebFont = require('webfontloader');

export default {
  init: function () {
    WebFont.load({
      typekit: { id: 'rvy8gwl' }
    });
  },
};
